export type RegisterDateFilter = {
    date_mode?: 'month' | 'range';
    month: number;
    year: number;
    start_date?: string;
    end_date?: string;
};

// Shared by list pagination and CSV export: never send month/year with a range.
export const registerDateParams = (filter: RegisterDateFilter) => filter.date_mode === 'range'
    ? { start_date: filter.start_date, end_date: filter.end_date }
    : { month: Number(filter.month), year: Number(filter.year) };

export const registerPeriodFileName = (filter: RegisterDateFilter) => filter.date_mode === 'range'
    ? `${filter.start_date}_to_${filter.end_date}`
    : `${filter.year}_${filter.month}`;

export const registerYears = (filter: RegisterDateFilter): number[] => {
    if (filter.date_mode !== 'range') return [Number(filter.year)];
    const first = Number(filter.start_date?.slice(0, 4));
    const last = Number(filter.end_date?.slice(0, 4));
    return Array.from({ length: Math.max(0, last - first + 1) }, (_, i) => first + i);
};
